import React from 'react';
import { Col } from 'reactstrap';

const CheckAlsoPage = ({ data }) => {
  const { title, page_profile_pic, page_description, page_url } = data;
  return (
    <Col
      xs={6}
      md={12}
      className="d-flex flex-column flex-md-row checkAlso-page-wrapper"
      onClick={() => window.open(page_url)}
    >
      <div className="checkAlso-pages-img-wrapper">
        <div
          className="checkAlso-pages-img"
          style={{
            backgroundImage: `url("${
              page_profile_pic !== 'false' ? page_profile_pic : `/placeholders/linked_page.png`
            }")`
          }}
        />
      </div>
      <div className="w-100">
        <h6 className="text-primary mb-4">
          <strong>{title}</strong>
        </h6>
        <div className="body-1" dangerouslySetInnerHTML={{ __html: page_description }} />
      </div>
    </Col>
  );
};

export default CheckAlsoPage;
